import { render, staticRenderFns } from "./LinkData.vue?vue&type=template&id=52753182&"
import script from "./LinkData.vue?vue&type=script&lang=js&"
export * from "./LinkData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports